import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertsCounterComponent } from './alerts-counter.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    AlertsCounterComponent,
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    AlertsCounterComponent,
  ],
})
export class AlertsCounterModule { }
